import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import BusinessIcon from '@mui/icons-material/Business'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'
import { ReactComponent as PortfolioIcon } from 'assets/images/portfolio.svg'
import GuruScopePicker from './GuruScopePicker'

const Strip = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: ${({ theme }) => theme.colors.primary}08;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
`

const Label = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.grey[200]};
`

const Pill = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.haiti};
  cursor: pointer;
  text-align: left;
  min-width: 0;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`

const PillIcon = styled.span`
  display: inline-flex;
  color: ${({ theme }) => theme.colors.primary};
`

const PillText = styled.span`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Caret = styled.span`
  display: inline-flex;
  color: ${({ theme }) => theme.colors.grey[200]};
`

const iconFor = type => {
  if (type === 'bp') return <BusinessIcon fontSize="small" />
  if (type === 'portfolio') return <PortfolioIcon style={{ width: 16, height: 16 }} />
  if (type === 'estate') return <AccountTreeOutlinedIcon fontSize="small" />
  return <AutoAwesomeOutlinedIcon fontSize="small" />
}

const labelFor = scope => {
  if (!scope || !scope.contextType) return 'All my Building Passports'
  if (scope.contextType === 'user') return 'All my Building Passports'
  return scope.contextLabel || (
    scope.contextType === 'bp' ? 'Building Passport' :
    scope.contextType === 'estate' ? 'Estate' :
    'Portfolio'
  )
}

const GuruScopeChip = ({ scope, onSelect }) => {
  const anchorRef = useRef(null)
  const [open, setOpen] = useState(false)

  return (
    <>
      <Strip>
        <Label>Asking about</Label>
        <Pill
          ref={anchorRef}
          type="button"
          onClick={() => setOpen(true)}
          aria-haspopup="dialog"
          aria-expanded={open}
        >
          <PillIcon>{iconFor(scope?.contextType)}</PillIcon>
          <PillText>{labelFor(scope)}</PillText>
          <Caret><KeyboardArrowDownIcon fontSize="small" /></Caret>
        </Pill>
      </Strip>
      <GuruScopePicker
        anchorEl={anchorRef.current}
        open={open}
        onClose={() => setOpen(false)}
        currentScope={scope}
        onSelect={onSelect}
      />
    </>
  )
}

export default GuruScopeChip
